import {Component, OnInit} from '@angular/core';
import {UserPrivilegeService} from '../../../services/common/user-privilege/user-privilege.service';
import {LoaderService} from '../../../services/common/loader-service/loader.service';
import {SyslogTypes} from '../../enums/settingsEnums';
import {WebSocketApiService} from './webSocket-api.service';
import {ConfirmationDialogComponent} from '../../../dialogs/confirmation-dialog/confirmation-dialog.component';
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'web-socket',
  templateUrl: './web-socket.component.html',
  styleUrls: ['./web-socket.component.scss']
})
export class WebSocketComponent implements OnInit {
  canSubmit: boolean;
  webSocketSettings: any = {};

  constructor(private userPrivilege: UserPrivilegeService,
              private loaderService: LoaderService,
              private webSocketApiService: WebSocketApiService,
              private dialog: MatDialog) {
  }

  ngOnInit(): void {
    this.loaderService.showMainContainer();

    this.canSubmit = this.userPrivilege.isAuthorized();
    this.initialize();
  }

  initialize(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();
    this.webSocketApiService.getWebSocketSettings().subscribe(webSocketSettings => {
      this.webSocketSettings = webSocketSettings;
      this.loaderService.hideMainContainer();
    });

  }

  submit(): void {
    const confirmationMessage = `If you change the username or password, update your router WebSocket Tunnel settings accordingly.`;

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '460px',
      data: {
        message: confirmationMessage
      }
    });

    dialogRef.componentInstance.onApply.subscribe(() => {
      this.webSocketApiService.editWebSocketSettings(this.webSocketSettings).subscribe(
        (data) => {
          dialogRef.close();
        });
    });

  }

  initialization(): void {
    this.canSubmit = this.userPrivilege.isAuthorized();

  }

}
